import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ComplexModalTemplate } from '@connect-services/client/components/complexe-modal/complex-modal-template.component';
import { CreateFieldInterventionService } from '@connect-services/client/services/create-field-intervention.service';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { ProgressBarComponent } from '@shared/client/components/progress-bar/progress-bar.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ComplexModalTemplate, ProgressBarComponent, RessourcesModule],
    selector: 'app-valid-entities-selection-modal',
    templateUrl: './fetch-entities-progress-modal.component.html',
})
export class FetchEntitiesProgressModalComponent {
    public readonly errorMessage = signal<string | undefined>(undefined);

    protected readonly createFieldInterventionService = inject(CreateFieldInterventionService);
    protected dialogRef = inject(MatDialogRef<FetchEntitiesProgressModalComponent>);
    protected readonly entitiesToFetchedCount = computed<number>(
        (): number => this.createFieldInterventionService.paginationParameters().totalItems ?? 0,
    );
    protected readonly fetchEntitiesCount = computed<number>((): number =>
        this.createFieldInterventionService.fetchedEntitiesCount(),
    );
}
